import { defineAsyncComponent } from "vue";

export default Object.assign(
  {},
  defineAsyncComponent(() => import("./column-textarea.vue")),
  { Filter: defineAsyncComponent(() => import("./filter.vue")) },
);
